<div class="login-dhl content-without-footer d-flex position-relative">
    <app-sprintpay-login class="position-absolute" [widthLogo]="'180'" [heightLogo]="'70'">
        <ng-container login-verbiage>
            <h4 class="mat-subtitle-1 text-center align-self-center mt-5">
                Please enter your DHL/CargoSprint - Sprintpay credentials to access your eCheck / Bank Account (ACH),
                credit cards and SprintPay Credit
            </h4>
        </ng-container>
    </app-sprintpay-login>
</div>
